/*
I used an untypeform..but maybe could have used a typed form
All listing views come to 'edit' with a mode stored in storage.

notifcation: 
delete == nothing
sumit = requestor.sponsor

all duplicates are removed in service.
*/

import { Location, ViewportScroller } from "@angular/common";
import {
    OnInit,
    Component,
    ChangeDetectorRef,
    ChangeDetectionStrategy,
    ViewChild, ElementRef, OnDestroy,
} from "@angular/core";

import { OverlayContainer } from "@angular/cdk/overlay";
import { ActivatedRoute, Router } from "@angular/router";
import { MatTableDataSource } from "@angular/material/table";

import { MatPaginator } from "@angular/material/paginator";
import { MatTableExporterDirective } from "mat-table-exporter";
import { WorkRequestService } from "@app-services/work-request.service";
import { Editor, Toolbar, toHTML } from 'ngx-editor';
import escapeHtml from 'escape-html';
import {
    Resource,
    WorkRequest,
    WorkRequestAuditView,
} from "@app-models/work-request";
import { Validators, UntypedFormBuilder, FormArray, AbstractControl, FormControl, FormGroup, UntypedFormGroup, ValidationErrors, AbstractControlOptions } from "@angular/forms";
import { DatePipe } from "@angular/common";
import {
    getCurrentUserFromStorage,
    getPreviousViewFromStorage,
    getScreenModeFromStorage,
} from "@app/utils/storage-utils";
import { AzureUser } from "@app-models/azure-user";
import { AlertService } from "@app/modules/alert";
import { GlobalConstants } from "@app/utils/global-constants";
import { GlobalService } from "@app-services/global.services";
import { environment } from "../../../environments/environment";
import { NgxSpinnerService } from "ngx-spinner";
import { distinctUntilChanged, pairwise } from "rxjs";
import { GraphService } from "@app/services/graph.service";
//import { EmailService } from "@app/services/email.service";
import { KeyVal } from "@app/models/common";

import { UserType } from "@app/models/common";
import Swal from "sweetalert2";
import { OrgDataService } from "@app/services/org-data.service";
import { WorkRequestBase } from "./work-request-base";

@Component({
    selector: "app-work-request-edit",
    templateUrl: "./work-request-edit.component.html",
    styleUrls: ["./work-request-edit.component.scss"],
    changeDetection: ChangeDetectionStrategy.Default,
})
export class WorkRequestEditComponent
    extends WorkRequestBase
    implements OnInit, OnDestroy {
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatTableExporterDirective, { static: true })
    exporter: MatTableExporterDirective;

    //------------------------------------------
    // Constants
    //------------------------------------------
    infoMesageOptions = {
        autoClose: true,
        keepAfterRouteChange: false,
    };
    errorMesageOptions = {
        autoClose: false,
        keepAfterRouteChange: true,
    };

    saveMesageOptions = {
        autoClose: true,
        keepAfterRouteChange: true,
    };

    errorMessage = "message";
    msg = {
        isClosed: "This work request has been closed and cannot be changed",
        isSubmitted:
            "This work request has been submitted and cannot be changed by the initiator.",
        isNotSubmitted:
            "This work request has NOT been submitted by the user. It cannot be changed.",
        isNotApproved: "This timesheet has NOT been approved by the manager.",

        saved: "The work request has been saved.",
        deleted: "The work request has been deleted.",
        submitted: "The work request has been submitted to Enterprise Technology.",
        internalReview: "The work request has been set to internal review.",
        inProgress: "The work request has been set to in-progress.",
        closed: "The work request has been set to closed.",

        entryNotFound: "The work request was not found",
        screenTitle: "should I have something here?",
    };

    subtitle = `Enter a request by selecting a request type and filling in the form details as best as possible. 
   The request can be saved as a <b>Draft</b> until it is officially <b>Submitted for Review</b> to Enterprise Technology.
   Once submitted the request cannot be changed by the initiator.`;

    DATE_FORMAT = "yyyy-MM-dd";
    DATE_TIME_FORMAT = "yyyy-MM-dd h:mm:ss a";

    QUESTION_NO = "No";
    QUESTION_YES = "Yes";
    yesNoOptions = [
        { key: this.QUESTION_YES, value: this.QUESTION_YES },
        { key: this.QUESTION_NO, value: this.QUESTION_NO },
    ];
    //quillEditorModules = {}
    href = "";

    ADMIN_MODE = GlobalConstants.REQUEST_FORM_MODE_ADMIN;
    USER_MODE = GlobalConstants.REQUEST_FORM_MODE_USER;
    PM_MODE = GlobalConstants.REQUEST_FORM_MODE_PM;

    REQUEST_TYPE_PROJECT = GlobalConstants.REQUEST_TYPE_PROJECT;
    REQUEST_TYPE_CONSULTATION = GlobalConstants.REQUEST_TYPE_CONSULTATION;

    PROJECT_NOT_STARTED = "not-started"; //match: GlobalConstants.projectsatus value.

    tooltip = {
        requestor:
            "Admin users have the option to set the requestor. Leave blank to default to logged in user",
        pia: "A Privacy Impact Assessment (PIA) is a type of impact assessment conducted by an organization such as a government agency or corporation to determine the impact that a new technology project, initiatives or proposed programs and policies might have on the privacy of individuals.",
        spp: "Strategic Planning Process (formally the Multi-Year Planning process) is the new end-to-end annual business planning process of the government.  Through this process, Supply Ontario will submit its multi-year funding requirements to be able to deliver on its mandated priorities.",
        tra: "A Threat Risk Assessment (TRA) is a formalized process which informs Business Owners of the risks to their Information and Information Technology (I&IT) systems and provides recommendation about risk treatment and management options.",
        emailLookup:
            "Start entering first or last name. Matching azure users will show.",
        apiRequirements: "Enter API requirements. If unsure, enter 'unsure'",
        tShirt:
            "Small - App Overlay \
                \n\nMedium - Small App deployment with a few stakeholders \
                \n\nLarge - Full org deployment with  a medium to large app, a couple integrations \
                \n\nX-Large - Typically External facing, High Data sensitivity, Lots of integration",
        sponsor:
            "The sponsor is included in the email notification when a request is submitted to Enterprise Technology.",
        priority:
            "1 - All work has stopped until this issue is resolved. \
                \n\n2 - required to be done before other things \
                \n\n3 - ordinary flow of work \
                \n\n4 - nice to have, but not required \
                \n\n5 - informational only",
        ippmStatus:
            "Integrated Project and Performance Management Framework (IPPM) Status",
        pmMilestones_old:
            "Milestones are included in the project status report and optionally included in the project dashboard as key updates.",
        pmMilestones: "Milestones are included in the project status report.",
        requestResources:
            "Request resources are assigned to identify employees working on the request. A user in a Project Manager role allows that user to update PM related fields of the request.",
        department:
            "Department is defaulted to user's department, but it can be cleared and changed via the dropdown",
        sensitivity:
            "High sensitivity	- Unauthorized disclosure could result in loss of life or impact to public safety, significant loss of confidence in or embarrassment to government, extremely serious personal or enterprise injury, major economic impact, sabotage or terrorism, or significant financial loss or social hardship. \
                    \n\nMedium sensitivity- Unauthorized disclosure could result in serious personal or enterprise injury, loss of competitive advantage, loss of confidence in a government program, moderate financial loss, or damage to partnerships or reputations. \
                    \n\nLow sensitivity	- Unauthorized disclosure could result in minor injury to persons, minor financial loss, slight embarrassment, or inconvenience. \
                    \n\nUnclassified - Disclosure will not result in any harm or injury and does not require prior authorization.",
        trbCheckpoints:
            "There are three governance checkpoints for the Technology Review Board (TRB), technology governance point (TGP) 0,1,2 ",
        projectType:
            "Project Type is used in the project dashboard and should be entered. \
                    \n\nEnterprise - on the SPP / Corporate Goals list. \
                    \n\nOperations - Enterprise Technology Operations driven projects.",
    };

    departments: KeyVal[] = [];

    //#region lookup data
    trbCheckpoints: KeyVal[] = [
        {
            key: "TGP-0",
            value: "TGP-0 - Intake and TRB assessment of initiative request",
        },
        { key: "TGP-1", value: "TGP-1 - Review of governance compliance" },
        {
            key: "TGP-2",
            value:
                "TGP-2 - Approval to close out initiative governance requirements ",
        },
    ];

    PROJECT_METHODOLOGY_WATERFALL = "Waterfall";
    PROJECT_METHODOLOGY_AGILE = "Agile";
    PROJECT_METHODOLOGY_HYBRID = "Hybrid";

    projectMethodologies: KeyVal[] = [
        {
            key: this.PROJECT_METHODOLOGY_WATERFALL,
            value: this.PROJECT_METHODOLOGY_WATERFALL,
        },
        {
            key: this.PROJECT_METHODOLOGY_AGILE,
            value: this.PROJECT_METHODOLOGY_AGILE,
        },
        {
            key: this.PROJECT_METHODOLOGY_HYBRID,
            value: this.PROJECT_METHODOLOGY_HYBRID,
        },
    ];

    checkpointsOptions: { [index: string]: any } = {
        "Work Order": [
            { key: "Queued", value: "Queued" },
            { key: "In-Progress Assessing", value: "In-Progress Assessing" },
            { key: "Fulfillment", value: "Fulfillment" },
            { key: "Closed", value: "Closed" },
            { key: "Cancelled", value: "Cancelled" },
        ],
        Consultation: [
            { key: "Queued", value: "Queued" },
            { key: "In-Progress Assessing", value: "In-Progress Assessing" },
            { key: "Closed", value: "Closed" },
            { key: "Cancelled", value: "Cancelled" },
        ],
        Project: {
            Waterfall: [
                { key: "Queued", value: "Queued" },
                {
                    key: "In-Progress Intro Meeting",
                    value: "In-Progress Intro Meeting",
                },
                {
                    key: "Pre-Charter / Discovery Stage",
                    value: "Pre-Charter / Discovery Stage",
                },
                { key: "Charter", value: "Charter" },
                { key: "Solutions Design", value: "Solutions Design" },
                { key: "Build", value: "Build" },
                { key: "Testing", value: "Testing" },
                { key: "Release", value: "Release" },
                { key: "Project Closeout", value: "Project Closeout" },
                { key: "Project Paused", value: "Project Paused" },
                { key: "Project Cancelled", value: "Project Cancelled" },
            ],

            Agile: [
                { key: "Queued", value: "Queued" },
                {
                    key: "In-Progress Intro Meeting",
                    value: "In-Progress Intro Meeting",
                },
                {
                    key: "Pre-Charter / Discovery Stage",
                    value: "Pre-Charter / Discovery Stage",
                },
                { key: "Charter", value: "Charter" },
                { key: "Phase 1", value: "Phase 1" },
                { key: "Project Closeout", value: "Project Closeout" },
                { key: "Project Paused", value: "Project Paused" },
                { key: "Project Cancelled", value: "Project Cancelled" },
            ],
            Hybrid: [
                { key: "Queued", value: "Queued" },
                {
                    key: "In-Progress Intro Meeting",
                    value: "In-Progress Intro Meeting",
                },
                {
                    key: "Pre-Charter / Discovery Stage",
                    value: "Pre-Charter / Discovery Stage",
                },
                { key: "Charter", value: "Charter" },
                { key: "Phase 1", value: "Phase 1" },
                { key: "Project Closeout", value: "Project Closeout" },
                { key: "Project Paused", value: "Project Paused" },
                { key: "Project Cancelled", value: "Project Cancelled" },
            ],
        },
    };

    sensitivityLevels: KeyVal[] = [
        { key: "High", value: "High" },
        { key: "Medium", value: "Medium" },
        { key: "Low", value: "Low" },
        { key: "Unclassified", value: "Unclassified" },
    ];

    projectVisibility: any[] = [
        { key: false, value: "All Access" },
        { key: true, value: "Restricted Access" },
    ];

    authenticationMethods: KeyVal[] = [
        { key: "AD", value: "AD / Microsoft Entra ID" },
        { key: "SSO", value: "SSO - Single Sign On" },
        { key: "PKI", value: "PKI - OPS Public Key Infrastructure" },
        { key: "LDAP", value: "LDAP - On-Premises" },
        { key: "NONE", value: "NONE - No authentication needed" },
    ];

    tShirtSizes: KeyVal[] = [
        { key: "Small", value: "Small" },
        { key: "Medium", value: "Medium" },
        { key: "Large", value: "Large" },
        { key: "X-Large", value: "X-Large" },
    ];

    ippmStatuses: KeyVal[] = [
        { key: "Pre-Submission", value: "Pre-Submission" },
        { key: "Gate 1", value: "Gate 1" },
        { key: "Gate 2", value: "Gate 2" },
    ];

    projectTypes = GlobalConstants.projectTypes;

    projectGovernanceSources: KeyVal[] = [
        { key: "Enterprise Technology", value: "Enterprise Technology" },
        {
            key: "IPPM/Project Steering Commitee",
            value: "IPPM/Project Steering Commitee",
        },
        { key: "Project Steering Commitee", value: "Project Steering Commitee" },
    ];

    fundingSources: KeyVal[] = [
        { key: "CDDO IT", value: "CDDO IT" },
        { key: "Finance", value: "Finance" },
        { key: "HR", value: "HR" },
        { key: "SCO", value: "SCO" },
        { key: "TDB", value: "TDB" },
    ];

    portfolioSources: KeyVal[] = [
        { key: "Enterprise Solutions", value: "Enterprise Solutions" },
        { key: "Security Modernization", value: "Security Modernization" },
        {
            key: "Service Planning & Delivery",
            value: "Service Planning & Delivery",
        },
    ];

    projectCategorySources: KeyVal[] = [
        { key: "Cyber Services", value: "Cyber Services" },
        { key: "Enterprise Application", value: "Enterprise Application" },
        { key: "Governance", value: "Governance" },
        {
            key: "IT Management and Reporting",
            value: "IT Management and Reporting",
        },
        { key: "Business Relationship", value: "Business Relationship" },
        {
            key: "Identity & Access Management",
            value: "Identity & Access Management",
        },
        { key: "Information Records", value: "Information Records" },
        { key: "Solution Design", value: "Solution Design" },
        { key: "Service Management", value: "Service Management" },
        { key: "Integration", value: "Integration" },
    ];

    businessSponsors: KeyVal[] = [
        { key: "CFO", value: "CFO" },
        { key: "CHRO", value: "CHRO" },
        { key: "CSPP", value: "CSPP" },
        { key: "CDDO", value: "CDDO" },
        { key: "CSO", value: "CSO" },
        { key: "CEO", value: "CEO" },
        { key: "GSCS", value: "GSCS" },
        { key: "COO", value: "COO" },
    ];

    projectStatuses = GlobalConstants.projectStatuses;
    statusValues = GlobalConstants.statusValues;
    resetStatus = "";

    requestTypes = GlobalConstants.requestTypeValues;
    applicationTypes: KeyVal[] = [
        { key: "Cloud", value: "Cloud" },
        { key: "Thin", value: "Thin" },
        { key: "Thick", value: "Thick" },
        { key: "OPS Application", value: "OPS Application" },
        { key: "Not Applicable", value: "Not Applicable" },
    ];

    projectRoles: KeyVal[] = [
        { key: "Azure Administrator", value: "Azure Administrator" },
        { key: "Business Analyst", value: "Business Analyst" },
        {
            key: "Cyber Security Risk Advisor",
            value: "Cyber Security Risk Advisor",
        },
        { key: "Cyber Security Specialist", value: "Cyber Security Specialist" },
        { key: "Database Administrator", value: "Database Administrator" },
        { key: "Director", value: "Director" },
        { key: "Enterprise Architect", value: "Enterprise Architect" },
        {
            key: "Information Security Officer",
            value: "Information Security Officer",
        },
        { key: "IT Architect", value: "IT Architect" },
        {
            key: GlobalConstants.PROJECT_IT_LEAD_ROLE,
            value: GlobalConstants.PROJECT_IT_LEAD_ROLE,
        },
        { key: "IT Operations Coordinator", value: "IT Operations Coordinator" },
        { key: "ITSM Process Analyst", value: "ITSM Process Analyst" },
        { key: "JR Operations Support", value: "JR Operations Support" },
        { key: "Manager", value: "Manager" },
        { key: "Product Manager", value: "Product Manager" },
        {
            key: GlobalConstants.PROJECT_MANAGER_ROLE,
            value: GlobalConstants.PROJECT_MANAGER_ROLE,
        },
        { key: "PM Delegate", value: "PM Delegate" },
        { key: "Program Manager", value: "Program Manager" },
        { key: "Senior System Analyst", value: "Senior System Analyst" },
        { key: "Senior Solution Designer", value: "Senior Solution Designer" },
        { key: "Systems Analyst", value: "Systems Analyst" },
        { key: "Technical Writer", value: "Technical Writer" },
        { key: "Technology Specialist", value: "Technology Specialist" },
    ];


    consultationTypes = GlobalConstants.consultationTypeValues;
     

    //#endregion

    checkpoints = this.checkpointsOptions["Consultation"];
    milestoneReportingError = "";

    departmentReadOnlyInd = false;

    //------------------------------------------
    //
    //------------------------------------------

    newWorkRequest: WorkRequest = {
        partOfSppOpPlan: null,
        traSosCompleted: null,
        executiveApproval: null,
        piaCompleted: null,
        diasterRecoveryNeeded: null,
    };

    formError = "";

    systemDate: Date = new Date();
    userType: UserType;

    //getting existing into this structure should be ok
    workRequest: WorkRequest = this.newWorkRequest;

    workRequestAuditView: MatTableDataSource<WorkRequestAuditView>;
    displayedAuditlogColumns = [
        "userAction",
        "eventUserId",
        "eventDateUTC",
        "oldValues",
        "newValues",
    ];
    stdAuditlogColumns = [
        "userAction",
        "eventUserId",
        "eventDateUTC",
        "oldValues",
        "newValues",
    ];
    exportAuditlogColumns = [
        "wrNumber",
        "requestorName",
        "requestorEmail",
        "userAction",
        "eventUserId",
        "eventDateUTC",
        "oldValues",
        "newValues",
    ];

    //PROJECT_REQUEST_TYPE = 'Project';

    currentUser: AzureUser;

    //someAzureUsers: AzureUser[] = [{ displayName : "one one", id: "1"},{ displayName : "one two", id: "2"}];
    defaultAzureUsers: AzureUser[] = [
        { displayName: "type more characters to begin loading...", id: "-1" },
    ];
    //filteredAzureUsers: Observable<AzureUser[]> = of(this.azureUsers);
    filteredAzureUsers: AzureUser[] = this.defaultAzureUsers;

    //currentUserManager: AzureUser;
    firstDayofMonth = new Date(
        this.systemDate.getFullYear(),
        this.systemDate.getMonth(),
        1
    );
    lastDayofMonth = new Date(
        this.systemDate.getFullYear(),
        this.systemDate.getMonth() + 1,
        0
    );

    STATUS_CLOSED = GlobalConstants.STATUS_CLOSED; //since used in html
    progressStatusLevel = 0;

    skipEmailNotifications: FormControl = new FormControl(false);
    showSkipEmailCheckBox = false;
    //Button controls
    btnSaveHide = true;
    btnDeleteHide = true;
    btnSubmitHide = true;
    btnUpdateHide = true;
    btnInternalReviewHide = true;
    btnInProgressHide = true;
    btnClosedHide = true;
    btnDisableButtons = false;
    btnUpdatePMHide = true;
    btnDisableUpdatePMButton = false;

    btnDisablePMButtons = false;

    editor1: Editor;
    editor2: Editor;
    editor3: Editor;
    editor4: Editor;
    editor5: Editor;
    editor6: Editor;
    editor7: Editor;
    editor8: Editor;

    toolbar: Toolbar = [
        ["bold", "italic"],
        ["underline", "strike"],
        ["code", "blockquote"],
        ["ordered_list", "bullet_list"],
        [{ heading: ["h1", "h2", "h3", "h4", "h5", "h6"] }],
        ["link"],
        // ['link', 'image'],
        ["text_color", "background_color"],
        ["align_left", "align_center", "align_right", "align_justify"],
    ];

    workRequestForm = this.formBuilder.group({});

    pmForm = this.formBuilder.group({});

    CHARS_TO_LOOKUP_AD = 2;

    //it's better to use onNgInit to initialize data vs doing it in the constructor.
    constructor(
        private _overlayContainer: OverlayContainer,

        public datePipe: DatePipe,
        private changeDetectorRef: ChangeDetectorRef,
        private route: ActivatedRoute,
        private router: Router,
        protected override workRequestService: WorkRequestService,
        private formBuilder: UntypedFormBuilder,
        private location: Location,
        private globalService: GlobalService,
        private graphService: GraphService,
       // private emailService: EmailService,
        private viewportScroller: ViewportScroller,
        private spinner: NgxSpinnerService,
        private alertService: AlertService,
        private orgDataService: OrgDataService,
        private el: ElementRef
    ) {
        super(workRequestService);
        //this.screenMode = GlobalConstants.REQUEST_FORM_MODE_USER;
        this.href = this.router.url;
    }
    ngOnDestroy(): void {
        this.editor1.destroy();
        this.editor2.destroy();
        this.editor3.destroy();
        this.editor4.destroy();
        this.editor5.destroy();
        this.editor6.destroy();
        this.editor7.destroy();
        this.editor8.destroy();
    }

    //--------------------------
    // Life Cycle Events
    //--------------------------
    ngOnInit(): void {
        this.editor1 = new Editor();
        this.editor2 = new Editor();
        this.editor3 = new Editor();
        this.editor4 = new Editor();
        this.editor5 = new Editor();
        this.editor6 = new Editor();
        this.editor7 = new Editor();
        this.editor8 = new Editor();

        this.systemDate = this.globalService.getSystemDate();

        this.workRequestAuditView = new MatTableDataSource<WorkRequestAuditView>();
        this.screenMode = getScreenModeFromStorage();
        this.userType = this.globalService.checkGroupAccess();

        // this needs to be done before end of init and can't be in async data retrieval or you will get form control errors
        // and unexpected issues.
        this.setUpForm();

        //Don't allow status reset to include Draft as option.
        this.statusValues = this.statusValues.filter((obj) => {
            return obj.key !== GlobalConstants.STATUS_DRAFT;
        });

        this.setDepartmentDropdown();

        this.currentUser = getCurrentUserFromStorage();
        this.route.paramMap.subscribe((params) => {
            const id = +params.get("id")!;
            const type = params.get("type");
            if (id) {
                this.initializeExistingEntry(id);
            } else {
                this.initializeNewEntry(type);
            }
        });

        this.viewportScroller.scrollToPosition([0, 0]);
        this.workRequestAuditView.paginator = this.paginator;

        if (!environment.sendNotificationOnSubmit) {
            this.tooltip.sponsor = "";
        }
    }

    setUpForm() {
        this.workRequestForm = this.formBuilder.group({
            requestType: ["", [Validators.required]],
            consultationType: [""],
            subject: ["", [Validators.required]],
            department: ["", [Validators.required]],

            sponsor: new FormControl(""),
            sponsorEmail: [""],
            sponsorAzureId: [""],
            sponsorWorkRequestId: [0],
            sponsorResourceId: [0],

            requestor: new FormControl(""),
            requestorEmail: [""],
            requestorAzureId: [""],
            requestorWorkRequestId: [0],
            requestorResourceId: [0],

            applicationOwner: new FormControl(""),
            applicationOwnerEmail: [null],
            applicationOwnerAzureId: [null],
            applicationOwnerWorkRequestId: [0],
            applicationOwnerResourceId: [0],

            businessRequirements: [
                "",
                [Validators.required, Validators.minLength(30)],
            ],
            desiredOutcome: ["", []],
            externalInvolvement: ["", []],
            requestNotes: [null, []],
            requestMilestones: this.formBuilder.array([]),
            partOfSppOpPlan: [null, []],
            approvedBudget: ["", []],
            executiveApproval: [null, []],
            businessSponsor: [null, []],
            registrationRequired: [null, []],
            registrationReason: [null, []],
            traSosCompleted: [null, []],
            sensitivityLevel: [null, []],
            piaCompleted: [null, []],
            applicationType: [null, []],
            diasterRecoveryNeeded: [null, []],
            authenticationMethod: [null, []],
            numberOfUsers: [null, []],
            publicFacingURLNeeded: [null, []],
            apiRequirements: [null, []],

            checkpoint: [null, []],
            trbCheckpoint: [null, []],
            phaseInfo: [null, []],
            priorityLevel: [null, []],
            numberOfEnvironments: [null, []],
            tShirtSize: [null, []],
            ippmStatus: [null, []],
            projectType: [null, []],
            fundingSource: [null, []],
            projectGovernance: [null, []],
            portfolio: [null, []],
            projectCategory: [null, []],
            projectTitle: [null, []],
            projectMethodology: [null, []],
            sppInfo: [null, []],
            traPiaSasRating: [null, []],
            requestResources: this.formBuilder.array([]),
            notes: [null, []],
            resolution: [null, []],
            restrictedVisibility: [null, []],
        });

        const applicationOwnerControl =
            this.workRequestForm.get("applicationOwner");
        applicationOwnerControl?.valueChanges
            .pipe(
                distinctUntilChanged(),
                pairwise() // gets a pair of old and new value
            )
            .subscribe(([oldValue, newValue]) => {
                if (
                    newValue == null ||
                    (newValue != oldValue && newValue.length >= this.CHARS_TO_LOOKUP_AD)
                ) {
                    this.filterADAccount("applicationOwner", newValue);
                }
            });

        const requestorControl = this.workRequestForm.get("requestor");
        requestorControl?.valueChanges
            .pipe(
                distinctUntilChanged(),
                pairwise() // gets a pair of old and new value
            )
            .subscribe(([oldValue, newValue]) => {
                if (
                    newValue == null ||
                    (newValue != oldValue && newValue.length >= this.CHARS_TO_LOOKUP_AD)
                ) {
                    this.filterADAccount("requestor", newValue);
                }
            });
        
        const consultationTypeControl = this.workRequestForm.get("consultationType");

        //If the form request changes, remove or add required fields.
        this.workRequestForm
            .get("requestType")
            ?.valueChanges.pipe(
                distinctUntilChanged(),
                pairwise() // gets a pair of old and new value
            )
            .subscribe(([oldValue, requestType]) => {
                if (requestType !== GlobalConstants.REQUEST_TYPE_PROJECT) {
                    if (applicationOwnerControl) {
                        applicationOwnerControl.removeValidators(Validators.required);
                        applicationOwnerControl.updateValueAndValidity();
                        this.workRequestForm.get("projectMethodology")?.setValue(null);
                    }
                } else {
                    if (applicationOwnerControl) {
                        applicationOwnerControl.setValidators([Validators.required]);
                    }
                }
                if (requestType !== GlobalConstants.REQUEST_TYPE_CONSULTATION) {
                    if (consultationTypeControl) {
                        consultationTypeControl.removeValidators(Validators.required);
                        consultationTypeControl.updateValueAndValidity();
                        this.workRequestForm.get("consultationType")?.setValue(null);
                        
                    }
                } else {
                    if (consultationTypeControl) {
                        consultationTypeControl.setValidators([Validators.required]);
                    }
                }
                if (requestType === GlobalConstants.REQUEST_TYPE_CONSULTATION) {
                    this.workRequestForm.get("consultationType")?.setValue(this.consultationTypes[0].key);
                }
                //this gets called when form is filled wiping oit retreive value. Code restructure didn't fix issue.
                //just don't bother doing this. this is only an issue if Amdin change type while a checkpoint was already specified
                //. this is unlikely. (same for Projet methodology below)
                this.workRequestForm.get("checkpoint")?.setValue(null);
                this.setCheckpoints();
                this.setDynamicValidations();
                console.log("request type change detected");
            });

        const projectMethodologyControl =
            this.workRequestForm.controls["projectMethodology"];
        /*
            projectMethodologyControl.valueChanges
                .subscribe(() => {
                    this.workRequestForm.get('checkpoint')?.setValue(null);
                    this.setCheckpoints();
                });
            */
        projectMethodologyControl.valueChanges
            .pipe(
                distinctUntilChanged(),
                pairwise() // gets a pair of old and new value
            )
            .subscribe(() => {
                this.workRequestForm.get("checkpoint")?.setValue(null);
                this.setCheckpoints();
            });

        const sponsorControl = this.workRequestForm.get("sponsor");
        sponsorControl?.valueChanges
            .pipe(
                distinctUntilChanged(),
                pairwise() // gets a pair of old and new value
            )
            .subscribe(([oldValue, newValue]) => {
                //tried to allow backspace in field, but leads to too many issues.
                //if (newValue == null || (newValue != oldValue && newValue.length >  oldValue.length && newValue.length >=  this.CHARS_TO_LOOKUP_AD)) {
                if (
                    newValue == null ||
                    (newValue != oldValue && newValue.length >= this.CHARS_TO_LOOKUP_AD)
                ) {
                    this.filterADAccount("sponsor", newValue);
                }
            });

        this.pmForm = this.formBuilder.group(
            {
                projectDescription: [null, []],
                //need to do it this way or get() will return json and not text.
                inScope: new FormControl(""),
                outOfScope: new FormControl(""),
                risks: new FormControl(""),
                riskMitigation: new FormControl(""),
                objectives: new FormControl(""),
                decisions: new FormControl(""),
                keyAccomplishments: new FormControl(""),
                upcomingActivities: new FormControl(""),
                stakeholderResources: this.formBuilder.array([]),
                projectStartDate: new FormControl(null, []),
                projectDeliveryDate: new FormControl(null, []),
                projectRevisionDate: [null, []],
                projectRevisionReason: ["", []],
                projectStatus: [null, []],
                previousProjectStatus: [null, []],
                pmMilestones: this.formBuilder.array([]),
            },
            { validators: [this.formGroupPMCrossChecks] } as AbstractControlOptions
        );
    }

    formGroupPMCrossChecks(form: FormGroup): ValidationErrors | null {
        const startDate: Date = new Date(form.controls["projectStartDate"].value);
        const endDate: Date = new Date(form.controls["projectDeliveryDate"].value);
        //if one of the dates is not entered, remove the datelessthan error if it exists
        // we do this to keep any required errors that may also exist.
        if (
            !form.controls["projectStartDate"].value ||
            !form.controls["projectDeliveryDate"].value
        ) {
            const currentState = form.controls["projectDeliveryDate"].errors;
            if (currentState) {
                delete currentState["dateLessThan"];
                form.controls["projectDeliveryDate"].setErrors(currentState);
            }
            return null;
        }
        if (startDate >= endDate) {
            form.controls["projectDeliveryDate"].setErrors({ dateLessThan: true });
            return { dateLessThan: true };
        } else {
            form.controls["projectDeliveryDate"].setErrors(null);
        }
        return null;
    }

    //These validations only occur depending on data entry
    //TODO: Now with both PM and ADMIN is required, probably don't need that if at all.
    setDynamicValidations(newStatus?: string) {
  

        if ( this.workRequestForm.get("requestType")?.value === GlobalConstants.REQUEST_TYPE_CONSULTATION) {
            this.workRequestForm
                .get("consultationType")
                ?.setValidators([Validators.required]);
            this.workRequestForm.get("consultationType")?.updateValueAndValidity();
        }
        //We have defaults for projectTitle, so this probably isn't needed anymore.  We use the current status and not the newone deliberately.
        if (
            (this.workRequest.status === GlobalConstants.STATUS_IN_PROGRESS ||
                this.workRequest.status === GlobalConstants.STATUS_INTERNAL_REVIEW) &&
            this.workRequestForm.get("requestType")?.value ===   GlobalConstants.REQUEST_TYPE_PROJECT &&
            (this.screenMode === GlobalConstants.REQUEST_FORM_MODE_ADMIN ||
                this.screenMode === GlobalConstants.REQUEST_FORM_MODE_PM)
        ) {
            this.workRequestForm
                .get("projectTitle")
                ?.setValidators([Validators.required]);
            this.workRequestForm.get("projectTitle")?.updateValueAndValidity();
        } else {
            this.workRequestForm
                .get("projectTitle")
                ?.removeValidators(Validators.required);
            this.workRequestForm.get("projectTitle")?.updateValueAndValidity();
        }

        if (newStatus) {
            if (
                newStatus === GlobalConstants.STATUS_CLOSED &&
                this.workRequestForm.get("requestType")?.value !== GlobalConstants.REQUEST_TYPE_PROJECT
            ) {
                this.workRequestForm
                    .get("resolution")
                    ?.setValidators([Validators.required]);
                this.workRequestForm.get("resolution")?.updateValueAndValidity();
            } else {
                this.workRequestForm
                    .get("resolution")
                    ?.removeValidators(Validators.required);
                this.workRequestForm.get("resolution")?.updateValueAndValidity();
            }
        }

        if (this.screenMode === GlobalConstants.REQUEST_FORM_MODE_PM) {
            this.pmForm
                .get("projectDescription")
                ?.setValidators([Validators.required]);
            this.pmForm.get("projectDescription")?.updateValueAndValidity();
            this.pmForm.get("projectStartDate")?.setValidators([Validators.required]);
            this.pmForm.get("projectStartDate")?.updateValueAndValidity();
            this.pmForm
                .get("projectDeliveryDate")
                ?.setValidators([Validators.required]);
            this.pmForm.get("projectDeliveryDate")?.updateValueAndValidity();
            this.pmForm.get("projectStatus")?.setValidators([Validators.required]);
            this.pmForm.get("projectStatus")?.updateValueAndValidity();
            this.pmForm
                .get("previousProjectStatus")
                ?.setValidators([Validators.required]);
            this.pmForm.get("previousProjectStatus")?.updateValueAndValidity();
        } else {
            this.pmForm
                .get("projectDescription")
                ?.removeValidators([Validators.required]);
            this.pmForm.get("projectDescription")?.updateValueAndValidity();
            this.pmForm
                .get("projectStartDate")
                ?.removeValidators([Validators.required]);
            this.pmForm.get("projectStartDate")?.updateValueAndValidity();
            this.pmForm
                .get("projectDeliveryDate")
                ?.removeValidators([Validators.required]);
            this.pmForm.get("projectDeliveryDate")?.updateValueAndValidity();
            this.pmForm.get("projectStatus")?.removeValidators([Validators.required]);
            this.pmForm.get("projectStatus")?.updateValueAndValidity();
            this.pmForm
                .get("previousProjectStatus")
                ?.removeValidators([Validators.required]);
            this.pmForm.get("previousProjectStatus")?.updateValueAndValidity();
        }
        this.changeDetectorRef.detectChanges();
    }

    //----------------------------------------------------------------------------------
    initializeNewEntry(type: string | null) {
        if (!this.screenMode) {
            this.screenMode = GlobalConstants.REQUEST_FORM_MODE_USER;
        }
        this.workRequest = this.newWorkRequest;
        this.workRequest.workRequestId = 0;
        this.workRequest.requestMilestones = [];
        if (type) {
            this.workRequest.requestType = type;
        }
        this.workRequest.department = this.currentUser.department;
        if (this.workRequest.requestType === GlobalConstants.REQUEST_TYPE_CONSULTATION) {
            this.workRequest.consultationType = this.consultationTypes[0].key;
        }

        /*
            if (this.currentUser.department) {
                this.departmentReadOnlyInd = true;
            } else {
                this.departmentReadOnlyInd = false;
            }
            */
        this.workRequest.status = "";

        this.setDataInForm();
        this.setDynamicValidations();
        this.configureButtonOptions();
    }

    initializeExistingEntry(id: number) {
        if (!this.screenMode) {
            this.determineScreenMode(id).then(() => {
                this.retreiveWorkRequest(id);
            });
        } else {
            this.retreiveWorkRequest(id);
        }
    }

    /**
     * Get Request from DB
     * @param id
     */
    retreiveWorkRequest(id: number) {
        this.workRequest = this.newWorkRequest;
        this.spinner.show();
        this.workRequestService.getWorkRequest(id, this.screenMode).subscribe({
            next: (response: WorkRequest) => {
                this.workRequest = response;

                if (response === null) {
                    this.alertService.error(
                        this.msg.entryNotFound,
                        this.errorMesageOptions
                    );
                    this.spinner.hide();
                    this.router.navigate(["/home"]);
                }

                this.setDataInForm();
                this.setDynamicValidations();
                this.configureButtonOptions();
                setTimeout(() => {
                    if (this.screenMode === GlobalConstants.REQUEST_FORM_MODE_PM) {
                        this.scrollTo("ProjectManagement");
                    }
                }, 200);
                this.spinner.hide();
            },
            error: (err: any) => {
                this.alertService.error(
                    this.msg.entryNotFound,
                    this.errorMesageOptions
                );
                this.spinner.hide();
                this.router.navigate(["/home"]);
            },
        });
    }

    /*
      Configure the button option for varions scenerios.
      */
    configureButtonOptions() {
        this.btnDeleteHide = true;
        this.btnSaveHide = true;
        this.btnSubmitHide = true;
        this.btnInternalReviewHide = true;
        this.btnInProgressHide = true;
        this.btnClosedHide = true;
        this.btnUpdateHide = true;
        this.btnUpdatePMHide = true;
        this.setProgressLevel();
        this.resetStatus = this.workRequest.status || "";
        //special logic for PM Mode
        if (
            (this.screenMode == GlobalConstants.REQUEST_FORM_MODE_PM ||
                this.screenMode ===
                GlobalConstants.REQUEST_FORM_MODE_RESTRICTED_PROJECT) &&
            this.workRequest.status !== GlobalConstants.STATUS_CLOSED
        ) {
            this.disableForm(this.workRequestForm, null);
            //we will enable a few Request Admin fields for PMs
            this.workRequestForm.controls["projectTitle"].enable();
            this.workRequestForm.controls["checkpoint"].enable();
            this.workRequestForm.controls["trbCheckpoint"].enable();
            this.workRequestForm.controls["requestResources"].enable();
            this.workRequestForm.controls["projectGovernance"].enable();
            this.workRequestForm.controls["fundingSource"].enable();
            this.workRequestForm.controls["projectCategory"].enable();
            this.workRequestForm.controls["portfolio"].enable();

            this.disableWRButtons();
            this.btnUpdatePMHide = false;
            this.btnDisableUpdatePMButton = false;
        } else if (
            this.screenMode === GlobalConstants.REQUEST_FORM_MODE_READ_ONLY ||
            this.screenMode === GlobalConstants.REQUEST_FORM_MODE_SPONSORED ||
            this.screenMode === GlobalConstants.REQUEST_FORM_MODE_PROJECT ||
            this.screenMode === GlobalConstants.REQUEST_FORM_MODE_RESTRICTED_PROJECT
        ) {
            this.disableForm(this.workRequestForm, null);
            this.disableForm(this.pmForm, null);
            this.disableAllButtons();
        } else if (
            this.workRequest.status === "" ||
            this.workRequest.status == GlobalConstants.STATUS_DRAFT
        ) {
            this.btnDeleteHide = false;
            this.btnSaveHide = false;
            this.btnSubmitHide = false;
        } else if (this.workRequest.status === GlobalConstants.STATUS_SUBMITTED) {
            if (this.screenMode === GlobalConstants.REQUEST_FORM_MODE_USER) {
                this.disableForm(this.workRequestForm, this.msg.isSubmitted);
                this.disableWRButtons();
            } else {
                this.btnDeleteHide = false;
                this.btnUpdateHide = false;
                this.btnInternalReviewHide = false;

                if (
                    this.workRequest.requestType ===
                    GlobalConstants.REQUEST_TYPE_WORK_ORDER ||
                    this.workRequest.requestType ===
                    GlobalConstants.REQUEST_TYPE_CONSULTATION
                ) {
                    this.btnInternalReviewHide = true;
                    this.btnInProgressHide = false;
                }
            }
        } else if (
            this.workRequest.status == GlobalConstants.STATUS_INTERNAL_REVIEW
        ) {
            if (this.screenMode === GlobalConstants.REQUEST_FORM_MODE_USER) {
                this.disableForm(this.workRequestForm, this.msg.isSubmitted);
                this.disableWRButtons();
            } else {
                this.btnDeleteHide = false;
                this.btnUpdateHide = false;
                this.btnInProgressHide = false;
            }
        } else if (this.workRequest.status == GlobalConstants.STATUS_IN_PROGRESS) {
            if (this.screenMode === GlobalConstants.REQUEST_FORM_MODE_USER) {
                this.disableForm(this.workRequestForm, this.msg.isSubmitted);
            } else {
                this.btnDeleteHide = false;
                this.btnUpdateHide = false;
                this.btnClosedHide = false;
            }
        } else if (this.workRequest.status == GlobalConstants.STATUS_CLOSED) {
            this.disableForm(this.workRequestForm, this.msg.isClosed);
            this.disableForm(this.pmForm, null);
            this.disableAllButtons();
        }

        if (!this.btnSubmitHide || !this.btnInternalReviewHide || !this.btnInProgressHide || !this.btnClosedHide) {
            this.showSkipEmailCheckBox = true;
        }
    }

    setProgressLevel() {
        this.progressStatusLevel = 0;
        if (this.workRequest.status == GlobalConstants.STATUS_DRAFT) {
            this.progressStatusLevel = 1;
        } else if (this.workRequest.status == GlobalConstants.STATUS_SUBMITTED) {
            this.progressStatusLevel = 2;
        } else if (
            this.workRequest.status == GlobalConstants.STATUS_INTERNAL_REVIEW
        ) {
            this.progressStatusLevel = 3;
        } else if (this.workRequest.status == GlobalConstants.STATUS_IN_PROGRESS) {
            this.progressStatusLevel = 4;
        } else if (this.workRequest.status == GlobalConstants.STATUS_CLOSED) {
            this.progressStatusLevel = 5;
        }
    }

    disableForm(form: UntypedFormGroup, infoMsg: string | null) {
        if (infoMsg) {
            this.alertService.info(infoMsg, this.infoMesageOptions);
        }
        form.disable();
    }

    //--------------------------------------------------------
    //#region Request Millestone controls for form
    //--------------------------------------------------------

    get requestMilestones() {
        return this.workRequestForm.get("requestMilestones") as FormArray;
    }
    get requestMilestonesControls() {
        //return (<FormArray>this.workRequestForm.get("milestones")).controls;
        return (this.workRequestForm.controls["requestMilestones"] as FormArray)
            .controls as FormGroup[];
    }

    addRequestMilestone(
        workRequestMilestoneId: number,
        workRequestId: number,
        description: string,
        date: Date
    ) {
        const milestoneForm = this.formBuilder.group({
            description: [description, Validators.required],
            date: [date, Validators.required],
            workRequestMilestoneId: workRequestMilestoneId,
            workRequestId: workRequestId,
        });
        this.requestMilestones.push(milestoneForm);
        //(<FormArray>this.workRequestForm.get("milestones")).controls.push(milestoneForm)
    }

    addNewRequestMilestone() {
        const milestoneForm = this.formBuilder.group({
            description: ["", Validators.required],
            date: ["", Validators.required],
            workRequestMilestoneId: [0],
            workRequestId: [0],
        });
        this.requestMilestones.push(milestoneForm);
    }

    deleteRequestMilestone(index: number) {
        this.requestMilestones.removeAt(index);
    }

    //#endregion
    //--------------------------------------------------------
    //#region PM Millestone controls for form
    //--------------------------------------------------------

    get pmMilestones() {
        return this.pmForm.get("pmMilestones") as FormArray;
    }
    get pmMilestonesControls() {
        return (this.pmForm.controls["pmMilestones"] as FormArray)
            .controls as FormGroup[];
    }

    addPMMilestone(
        workRequestMilestoneId: number,
        workRequestId: number,
        description: string,
        date: Date,
        revisionDate: Date | null,
        status: string,
        showInReporting: boolean
    ) {
        const milestoneForm = this.formBuilder.group({
            description: [description, Validators.required],
            date: [date, Validators.required],
            revisionDate: [revisionDate],
            status: [status],
            showInReporting: [showInReporting],
            workRequestMilestoneId: workRequestMilestoneId,
            workRequestId: workRequestId,
        });
        this.pmMilestones.push(milestoneForm);
    }

    addNewPMMilestone() {
        const milestoneForm = this.formBuilder.group({
            description: ["", Validators.required],
            date: ["", Validators.required],
            revisionDate: [null],
            status: [null],
            showInReporting: [false],
            workRequestMilestoneId: [0],
            workRequestId: [0],
        });
        this.pmMilestones.push(milestoneForm);
    }

    deletePMMilestone(index: number) {
        this.pmMilestones.removeAt(index);
    }

    //#endregion
    //--------------------------------------------------------
    //#region project Resources controls for form
    //--------------------------------------------------------

    get requestResources() {
        return this.workRequestForm.get("requestResources") as FormArray;
    }

    addRequestResource(pr: Resource) {
        const projectRequestForm = this.formBuilder.group({
            name: [pr.name, Validators.required],
            email: [pr.email],
            azureId: [pr.azureId],
            role: [pr.role, Validators.required],
            resourceId: [pr.resourceId],
            workRequestId: [pr.workRequestId],
        });
        this.requestResources.push(projectRequestForm);
        this.setTriggerOnPR(projectRequestForm);
    }

    addNewProjectResource() {
        const projectRequestForm = this.formBuilder.group({
            name: ["", Validators.required],
            email: [""],
            azureId: [""],
            role: ["", Validators.required],
            resourceId: [0],
            workRequestId: [0],
        });
        this.requestResources.push(projectRequestForm);

        this.setTriggerOnPR(projectRequestForm);
    }

    setTriggerOnPR(form: UntypedFormGroup) {
        const nameControl = form.controls["name"];
        nameControl?.valueChanges
            .pipe(
                distinctUntilChanged(),
                pairwise() // gets a pair of old and new value
            )
            .subscribe(([oldValue, newValue]) => {
                console.log(oldValue, newValue);
                if (
                    newValue == null ||
                    (newValue != oldValue && newValue.length >= this.CHARS_TO_LOOKUP_AD)
                ) {
                    this.filterSubformResource(form, newValue);
                }
            });
    }
    filterSubformResource(form: UntypedFormGroup, name: string) {
        if (name == null) {
            //from a clear btn push
            form.get("name")?.setValue(null);
            form.get("email")?.setValue(null);
            form.get("azureId")?.setValue(null);
        } else {
            const ausers = this.graphService
                .findUsers(name)
                .then((azureUsers: AzureUser[]) => {
                    this.filteredAzureUsers = azureUsers;
                    if (this.filteredAzureUsers.length > 1) {
                        //this is make sure we clear out old values.
                        form.get("email")?.setValue(null);
                        form.get("azureId")?.setValue(null);
                    } else if (this.filteredAzureUsers.length === 1) {
                        form.get("name")?.setValue(this.filteredAzureUsers[0].displayName);
                        form.get("email")?.setValue(this.filteredAzureUsers[0].mail);
                        form.get("azureId")?.setValue(this.filteredAzureUsers[0].id);
                    }
                });
        }
        return;
    }

    deleteProjectResource(index: number) {
        this.requestResources.removeAt(index);
    }

    //#endregion
    //--------------------------------------------------------
    //#region stakeholder Resources controls for form
    //  filters and triggers
    //--------------------------------------------------------

    get stakeholderResources() {
        return this.pmForm.get("stakeholderResources") as FormArray;
    }

    addStakeholderResource(pr: Resource) {
        const stakeholderRequestForm = this.formBuilder.group({
            name: [pr.name, Validators.required],
            email: [pr.email],
            azureId: [pr.azureId],
            role: [pr.role, Validators.required],
            resourceId: [pr.resourceId],
            workRequestId: [pr.workRequestId],
        });
        this.stakeholderResources.push(stakeholderRequestForm);
        this.setTriggerOnSTH(stakeholderRequestForm);
    }

    addNewStakeholderResource() {
        const stakeholderRequestForm = this.formBuilder.group({
            name: ["", Validators.required],
            email: [""],
            azureId: [""],
            role: ["", Validators.required],
            resourceId: [0],
            workRequestId: [0],
        });
        this.stakeholderResources.push(stakeholderRequestForm);

        this.setTriggerOnSTH(stakeholderRequestForm);
    }

    setTriggerOnSTH(form: UntypedFormGroup) {
        const nameControl = form.controls["name"];
        nameControl?.valueChanges
            .pipe(
                distinctUntilChanged(),
                pairwise() // gets a pair of old and new value
            )
            .subscribe(([oldValue, newValue]) => {
                console.log(oldValue, newValue);
                if (
                    newValue == null ||
                    (newValue != oldValue && newValue.length >= this.CHARS_TO_LOOKUP_AD)
                ) {
                    this.filterSubformResource(form, newValue);
                }
            });
    }

    deleteStakeholderResource(index: number) {
        this.stakeholderResources.removeAt(index);
    }

    //#endregion
    //----------------------------------------------------------------------------------
    // Azure Sponsor typeahead
    //----------------------------------------------------------------------------------

    //When the user finally selects the value, there will be one more filter operation and the result should be 1 record.
    // Use it to set the email and azureID
    filterADAccount(property: string, name: string) {
        if (name == null) {
            //from a clear btn push
            this.workRequestForm.get(property)?.setValue(null);
            this.workRequestForm.get(property + "Email")?.setValue(null);
            this.workRequestForm.get(property + "AzureId")?.setValue(null);
        } else {
            const ausers = this.graphService
                .findUsers(name)
                .then((azureUsers: AzureUser[]) => {
                    this.filteredAzureUsers = azureUsers;
                    if (this.filteredAzureUsers.length > 1) {
                        this.workRequestForm.get(property + "Email")?.setValue(null);
                        this.workRequestForm.get(property + "AzureId")?.setValue(null);
                    } else if (this.filteredAzureUsers.length === 1) {
                        this.workRequestForm
                            .get(property)
                            ?.setValue(this.filteredAzureUsers[0].displayName);
                        this.workRequestForm
                            .get(property + "Email")
                            ?.setValue(this.filteredAzureUsers[0].mail);
                        this.workRequestForm
                            .get(property + "AzureId")
                            ?.setValue(this.filteredAzureUsers[0].id);
                    }
                });
        }
        return;
    }

    //#region form data routines
    setDataInForm() {
        this.workRequestForm
            .get("requestType")
            ?.setValue(this.workRequest.requestType);
        this.workRequestForm
            .get("consultationType")
            ?.setValue(this.workRequest.consultationType);
        this.workRequestForm.get("subject")?.setValue(this.workRequest.subject);
        this.workRequestForm
            .get("department")
            ?.setValue(this.workRequest.department);
        //this.workRequestForm.get("requestSponsor")?.setValue(this.workRequest.requestSponsor);
        if (this.workRequest.sponsors && this.workRequest.sponsors.length > 0) {
            this.workRequestForm
                .get("sponsor")
                ?.setValue(this.workRequest.sponsors[0].name);
            this.workRequestForm
                .get("sponsorEmail")
                ?.setValue(this.workRequest.sponsors[0].email);
            this.workRequestForm
                .get("sponsorAzureId")
                ?.setValue(this.workRequest.sponsors[0].azureId);
            this.workRequestForm
                .get("sponsorWorkRequestId")
                ?.setValue(this.workRequest.sponsors[0].workRequestId);
            this.workRequestForm
                .get("sponsorResourceId")
                ?.setValue(this.workRequest.sponsors[0].resourceId);
        }

        this.workRequestForm
            .get("businessRequirements")
            ?.setValue(this.workRequest.businessRequirements);
        this.workRequestForm
            .get("desiredOutcome")
            ?.setValue(this.workRequest.desiredOutcome);
        this.workRequestForm
            .get("externalInvolvement")
            ?.setValue(this.workRequest.externalInvolvement);
        this.workRequestForm
            .get("requestNotes")
            ?.setValue(this.workRequest.requestNotes);

        if (
            this.workRequest.applicationOwners &&
            this.workRequest.applicationOwners.length > 0
        ) {
            this.workRequestForm
                .get("applicationOwner")
                ?.setValue(this.workRequest.applicationOwners[0].name);
            this.workRequestForm
                .get("applicationOwnerEmail")
                ?.setValue(this.workRequest.applicationOwners[0].email);
            this.workRequestForm
                .get("applicationOwnerAzureId")
                ?.setValue(this.workRequest.applicationOwners[0].azureId);
            this.workRequestForm
                .get("applicationOwnerWorkRequestId")
                ?.setValue(this.workRequest.applicationOwners[0].workRequestId);
            this.workRequestForm
                .get("applicationOwnerResourceId")
                ?.setValue(this.workRequest.applicationOwners[0].resourceId);
        }
        this.workRequestForm
            .get("approvedBudget")
            ?.setValue(this.workRequest.approvedBudget);
        this.workRequestForm
            .get("partOfSppOpPlan")
            ?.setValue(this.workRequest.partOfSppOpPlan);
        this.workRequestForm
            .get("executiveApproval")
            ?.setValue(this.workRequest.executiveApproval);
        this.workRequestForm
            .get("businessSponsor")
            ?.setValue(this.workRequest.businessSponsor);
        this.workRequestForm
            .get("registrationRequired")
            ?.setValue(this.workRequest.registrationRequired);
        this.workRequestForm
            .get("registrationReason")
            ?.setValue(this.workRequest.registrationReason);
        this.workRequestForm
            .get("traSosCompleted")
            ?.setValue(this.workRequest.traSosCompleted);
        this.workRequestForm
            .get("sensitivityLevel")
            ?.setValue(this.workRequest.sensitivityLevel);
        this.workRequestForm
            .get("piaCompleted")
            ?.setValue(this.workRequest.piaCompleted);
        this.workRequestForm
            .get("applicationType")
            ?.setValue(this.workRequest.applicationType);
        this.workRequestForm
            .get("diasterRecoveryNeeded")
            ?.setValue(this.workRequest.diasterRecoveryNeeded);
        this.workRequestForm
            .get("authenticationMethod")
            ?.setValue(this.workRequest.authenticationMethod);
        this.workRequestForm
            .get("numberOfUsers")
            ?.setValue(this.workRequest.numberOfUsers);
        this.workRequestForm
            .get("publicFacingURLNeeded")
            ?.setValue(this.workRequest.publicFacingURLNeeded);
        this.workRequestForm
            .get("apiRequirements")
            ?.setValue(this.workRequest.apiRequirements);

        this.workRequestForm
            .get("priorityLevel")
            ?.setValue(this.workRequest.priorityLevel);
        this.workRequestForm
            .get("ippmStatus")
            ?.setValue(this.workRequest.ippmStatus);
        this.workRequestForm
            .get("numberOfEnvironments")
            ?.setValue(this.workRequest.numberOfEnvironments);
        this.workRequestForm
            .get("tShirtSize")
            ?.setValue(this.workRequest.tShirtSize);
        this.workRequestForm
            .get("projectMethodology")
            ?.setValue(this.workRequest.projectMethodology);
        this.workRequestForm
            .get("projectType")
            ?.setValue(this.workRequest.projectType);
        this.workRequestForm
            .get("projectTitle")
            ?.setValue(this.workRequest.projectTitle);
        this.workRequestForm
            .get("projectGovernance")
            ?.setValue(this.workRequest.projectGovernance);
        this.workRequestForm
            .get("fundingSource")
            ?.setValue(this.workRequest.fundingSource);
        this.workRequestForm
            .get("projectCategory")
            ?.setValue(this.workRequest.projectCategory);
        this.workRequestForm.get("portfolio")?.setValue(this.workRequest.portfolio);
        this.workRequestForm.get("phaseInfo")?.setValue(this.workRequest.phaseInfo);
        this.workRequestForm.get("sppInfo")?.setValue(this.workRequest.sppInfo);
        this.workRequestForm
            .get("traPiaSasRating")
            ?.setValue(this.workRequest.traPiaSasRating);
        this.workRequestForm.get("notes")?.setValue(this.workRequest.notes);
        this.workRequestForm
            .get("resolution")
            ?.setValue(this.workRequest.resolution);
        this.workRequestForm
            .get("restrictedVisibility")
            ?.setValue(this.workRequest.restrictedVisibility);

        this.workRequestForm
            .get("checkpoint")
            ?.setValue(this.workRequest.checkpoint);
        this.workRequestForm
            .get("trbCheckpoint")
            ?.setValue(this.workRequest.trbCheckpoint);

        this.workRequestForm
            .get("requestor")
            ?.setValue(this.workRequest.requestorName);
        //this.workRequestForm.get("requestorName")?.setValue(this.workRequest.requestorName);
        this.workRequestForm
            .get("requestorEmail")
            ?.setValue(this.workRequest.requestorEmail);
        this.workRequestForm
            .get("requestorAzureId")
            ?.setValue(this.workRequest.requestorAzureId);

        if (this.workRequest.requestMilestones) {
            for (const ms of this.workRequest.requestMilestones) {
                this.addRequestMilestone(
                    ms.workRequestMilestoneId!,
                    ms.workRequestId!,
                    ms.description!,
                    ms.date!
                );
            }
        }

        if (this.workRequest.requestResources) {
            for (const pr of this.workRequest.requestResources) {
                this.addRequestResource(pr);
            }
        }
        this.setCheckpoints();

        this.pmForm
            .get("projectDescription")
            ?.setValue(this.workRequest.projectDescription);
        this.pmForm
            .get("projectStartDate")
            ?.setValue(this.workRequest.projectStartDate);
        this.pmForm
            .get("projectDeliveryDate")
            ?.setValue(this.workRequest.projectDeliveryDate);
        this.pmForm
            .get("projectRevisionDate")
            ?.setValue(this.workRequest.projectRevisionDate);
        this.pmForm
            .get("projectRevisionReason")
            ?.setValue(this.workRequest.projectRevisionReason);
        this.pmForm.get("projectStatus")?.setValue(this.workRequest.projectStatus);
        this.pmForm
            .get("previousProjectStatus")
            ?.setValue(this.workRequest.previousProjectStatus);

        this.pmForm.get("inScope")?.setValue(this.workRequest.inScope);
        this.pmForm.get("outOfScope")?.setValue(this.workRequest.outOfScope);
        this.pmForm.get("risks")?.setValue(this.workRequest.risks);
        this.pmForm
            .get("riskMitigation")
            ?.setValue(this.workRequest.riskMitigation);

        this.pmForm.get("objectives")?.setValue(this.workRequest.objectives);
        this.pmForm.get("decisions")?.setValue(this.workRequest.decisions);
        this.pmForm
            .get("keyAccomplishments")
            ?.setValue(this.workRequest.keyAccomplishments);
        this.pmForm
            .get("upcomingActivities")
            ?.setValue(this.workRequest.upcomingActivities);

        if (this.workRequest.stakeholderResources) {
            for (const sth of this.workRequest.stakeholderResources) {
                this.addStakeholderResource(sth);
            }
        }
        if (this.workRequest.pmMilestones) {
            this.workRequest.pmMilestones.sort(
                (a, b) => new Date(a.date!).getTime() - new Date(b.date!).getTime()
            );
            for (const ms of this.workRequest.pmMilestones) {
                this.addPMMilestone(
                    ms.workRequestMilestoneId!,
                    ms.workRequestId!,
                    ms.description!,
                    ms.date!,
                    ms.revisionDate!,
                    ms.status!,
                    ms.showInReporting!
                );
            }
        }
        this.changeDetectorRef.detectChanges();
    }

    getDataFromForm() {
        //NOTE: I don't really need to get each value.
        //I can use the form.value unless I need to maniupulate the data, which i did a lot in timeentry
        this.workRequest.requestType =
            this.workRequestForm.get("requestType")?.value;
        this.workRequest.consultationType =
            this.workRequestForm.get("consultationType")?.value;
        this.workRequest.subject = this.workRequestForm.get("subject")?.value;
        this.workRequest.department = this.workRequestForm.get("department")?.value;
        if (this.workRequestForm.get("sponsor")?.value != null) {
            this.workRequest.sponsors = [
                {
                    name: this.workRequestForm.get("sponsor")?.value,
                    email: this.workRequestForm.get("sponsorEmail")?.value,
                    azureId: this.workRequestForm.get("sponsorAzureId")?.value,
                    workRequestId: this.workRequestForm.get("sponsorWorkRequestId")
                        ?.value,
                    resourceId: this.workRequestForm.get("sponsorResourceId")?.value,
                },
            ];
        } else {
            this.workRequest.sponsors = [];
        }
        this.workRequest.businessRequirements = this.workRequestForm.get(
            "businessRequirements"
        )?.value;
        this.workRequest.desiredOutcome =
            this.workRequestForm.get("desiredOutcome")?.value;
        this.workRequest.externalInvolvement = this.workRequestForm.get(
            "externalInvolvement"
        )?.value;
        this.workRequest.requestNotes =
            this.workRequestForm.get("requestNotes")?.value;
        //this.workRequest.applicationOwner = this.workRequestForm.get("applicationOwner")?.value;
        if (this.workRequestForm.get("applicationOwner")?.value != null) {
            this.workRequest.applicationOwners = [
                {
                    name: this.workRequestForm.get("applicationOwner")?.value,
                    email: this.workRequestForm.get("applicationOwnerEmail")?.value,
                    azureId: this.workRequestForm.get("applicationOwnerAzureId")?.value,
                    workRequestId: this.workRequestForm.get(
                        "applicationOwnerWorkRequestId"
                    )?.value,
                    resourceId: this.workRequestForm.get("applicationOwnerResourceId")
                        ?.value,
                },
            ];
        } else {
            this.workRequest.applicationOwners = [];
        }

        this.workRequest.approvedBudget =
            this.workRequestForm.get("approvedBudget")?.value;
        this.workRequest.partOfSppOpPlan =
            this.workRequestForm.get("partOfSppOpPlan")?.value;
        this.workRequest.executiveApproval =
            this.workRequestForm.get("executiveApproval")?.value;
        this.workRequest.businessSponsor =
            this.workRequestForm.get("businessSponsor")?.value;
        this.workRequest.registrationRequired = this.workRequestForm.get(
            "registrationRequired"
        )?.value;
        this.workRequest.registrationReason =
            this.workRequestForm.get("registrationReason")?.value;
        this.workRequest.traSosCompleted =
            this.workRequestForm.get("traSosCompleted")?.value;
        this.workRequest.sensitivityLevel =
            this.workRequestForm.get("sensitivityLevel")?.value;
        this.workRequest.piaCompleted =
            this.workRequestForm.get("piaCompleted")?.value;
        this.workRequest.applicationType =
            this.workRequestForm.get("applicationType")?.value;
        this.workRequest.diasterRecoveryNeeded = this.workRequestForm.get(
            "diasterRecoveryNeeded"
        )?.value;
        this.workRequest.authenticationMethod = this.workRequestForm.get(
            "authenticationMethod"
        )?.value;
        this.workRequest.numberOfUsers =
            this.workRequestForm.get("numberOfUsers")?.value;
        this.workRequest.publicFacingURLNeeded = this.workRequestForm.get(
            "publicFacingURLNeeded"
        )?.value;
        this.workRequest.apiRequirements =
            this.workRequestForm.get("apiRequirements")?.value;
        this.workRequest.requestMilestones =
            this.workRequestForm.get("requestMilestones")?.value;
        this.workRequest.requestResources =
            this.workRequestForm.get("requestResources")?.value;

        this.workRequest.priorityLevel =
            this.workRequestForm.get("priorityLevel")?.value;
        this.workRequest.ippmStatus = this.workRequestForm.get("ippmStatus")?.value;
        this.workRequest.numberOfEnvironments = this.workRequestForm.get(
            "numberOfEnvironments"
        )?.value;
        this.workRequest.tShirtSize = this.workRequestForm.get("tShirtSize")?.value;
        this.workRequest.projectMethodology =
            this.workRequestForm.get("projectMethodology")?.value;
        this.workRequest.projectType =
            this.workRequestForm.get("projectType")?.value;
        this.workRequest.fundingSource =
            this.workRequestForm.get("fundingSource")?.value;
        this.workRequest.projectGovernance =
            this.workRequestForm.get("projectGovernance")?.value;

        this.workRequest.portfolio = this.workRequestForm.get("portfolio")?.value;
        this.workRequest.projectCategory =
            this.workRequestForm.get("projectCategory")?.value;

        this.workRequest.projectTitle =
            this.workRequestForm.get("projectTitle")?.value;
        this.workRequest.notes = this.workRequestForm.get("notes")?.value;
        this.workRequest.resolution = this.workRequestForm.get("resolution")?.value;
        this.workRequest.restrictedVisibility = this.workRequestForm.get(
            "restrictedVisibility"
        )?.value;

        this.workRequest.checkpoint = this.workRequestForm.get("checkpoint")?.value;
        this.workRequest.trbCheckpoint =
            this.workRequestForm.get("trbCheckpoint")?.value;
        this.workRequest.phaseInfo = this.workRequestForm.get("phaseInfo")?.value;
        this.workRequest.sppInfo = this.workRequestForm.get("sppInfo")?.value;
        this.workRequest.traPiaSasRating =
            this.workRequestForm.get("traPiaSasRating")?.value;

        this.workRequest.requestorName =
            this.workRequestForm.get("requestor")?.value;
        this.workRequest.requestorEmail =
            this.workRequestForm.get("requestorEmail")?.value;
        this.workRequest.requestorAzureId =
            this.workRequestForm.get("requestorAzureId")?.value;
    }

    getPMDataFromForm() {
        this.workRequest.projectDescription =
            this.pmForm.get("projectDescription")?.value;
        this.workRequest.projectStartDate =
            this.pmForm.get("projectStartDate")?.value;
        this.workRequest.projectDeliveryDate = this.pmForm.get(
            "projectDeliveryDate"
        )?.value;
        this.workRequest.projectRevisionDate = this.pmForm.get(
            "projectRevisionDate"
        )?.value;
        this.workRequest.projectRevisionReason = this.pmForm.get(
            "projectRevisionReason"
        )?.value;

        this.workRequest.projectStatus = this.pmForm.get("projectStatus")?.value;
        this.workRequest.previousProjectStatus = this.pmForm.get(
            "previousProjectStatus"
        )?.value;
        //this sets a default value form when a request is set to in-progress and the PM hasn't updated anything yet.
        if (this.workRequest.projectStatus === null)
            this.workRequest.projectStatus = this.PROJECT_NOT_STARTED;
        if (this.workRequest.previousProjectStatus === null)
            this.workRequest.previousProjectStatus = this.PROJECT_NOT_STARTED;
        if (this.workRequest.projectTitle === null)
            this.workRequest.projectTitle = this.workRequest.subject;

        this.workRequest.inScope = this.returnHTML(
            this.pmForm.get("inScope")?.value
        );
        this.workRequest.outOfScope = this.returnHTML(
            this.pmForm.get("outOfScope")?.value
        );
        this.workRequest.risks = this.returnHTML(this.pmForm.get("risks")?.value);
        this.workRequest.riskMitigation = this.returnHTML(
            this.pmForm.get("riskMitigation")?.value
        );
        this.workRequest.objectives = this.returnHTML(
            this.pmForm.get("objectives")?.value
        );
        this.workRequest.decisions = this.returnHTML(
            this.pmForm.get("decisions")?.value
        );
        this.workRequest.upcomingActivities = this.returnHTML(
            this.pmForm.get("upcomingActivities")?.value
        );
        this.workRequest.keyAccomplishments = this.returnHTML(
            this.pmForm.get("keyAccomplishments")?.value
        );

        this.workRequest.stakeholderResources = this.pmForm.get(
            "stakeholderResources"
        )?.value;
        this.workRequest.pmMilestones = this.pmForm.get("pmMilestones")?.value;
    }

    //The ngx-editor field will be; null, HTML or a jsonDoc [which seems to occur when going form null field to data after user enter something]
    //Instead of initializing the editor fields as null, I could probably have created them as HTML <p></p> and not worry
    //about the type of data in the editor. but this works and I prefer NULL in DB if no data.
    returnHTML(formField: any) {
        if (formField && formField.type && formField.type === "doc") {
            return toHTML(formField);
        } else {
            return formField;
        }
    }
    setCheckpoints() {
        const rt = this.workRequestForm.get("requestType")?.value;
        const prjmeth = this.workRequestForm.get("projectMethodology")?.value;
        if (rt != GlobalConstants.REQUEST_TYPE_PROJECT && rt != null) {
            this.checkpoints = this.checkpointsOptions[rt];
        } else {
            this.checkpoints =
                this.checkpointsOptions[GlobalConstants.REQUEST_TYPE_PROJECT][
                this.PROJECT_METHODOLOGY_WATERFALL
                ];
            if (
                prjmeth != null &&
                (prjmeth == this.PROJECT_METHODOLOGY_AGILE ||
                    prjmeth == this.PROJECT_METHODOLOGY_HYBRID)
            ) {
                const updatedCheckpoints: KeyVal[] = [];
                const phaseparts = this.workRequest.checkpoint?.split(" ");
                let phaseLevelNeeded = 0;
                if (phaseparts && phaseparts.length > 1 && phaseparts[0] == "Phase") {
                    phaseLevelNeeded = Number(phaseparts[1]) + 1;
                }

                for (const ck of this.checkpointsOptions[
                    GlobalConstants.REQUEST_TYPE_PROJECT
                ][prjmeth]) {
                    updatedCheckpoints.push(ck);
                    if (ck.key.indexOf("Phase") > -1) {
                        const phaseparts = ck.key.split(" ");
                        let currentLevel = 0;
                        if (
                            phaseparts &&
                            phaseparts.length > 1 &&
                            phaseparts[0] == "Phase"
                        ) {
                            currentLevel = Number(phaseparts[1]);
                        }
                        for (let i = currentLevel + 1; i <= phaseLevelNeeded; i++) {
                            updatedCheckpoints.push({
                                key: "Phase " + i,
                                value: "Phase " + i,
                            });
                        }
                    }
                }
                this.checkpoints = updatedCheckpoints;
            }
        }
    }
    //#endregion

    //------------------------------------------
    //#region Button Events
    //------------------------------------------
    disablePMButtons() {
        this.btnDisablePMButtons = true;
    }
    disableWRButtons() {
        this.btnDisableButtons = true;
    }
    disableAllButtons() {
        this.btnDisableButtons = true;
        this.btnDisablePMButtons = true;
    }
    enableAllButtons() {
        this.btnDisableButtons = false;
        this.btnDisablePMButtons = false;
        //this.changeDetectorRef.detectChanges();
    }
    //#endregion
    //------------------------------------------
    // Form Actions
    //------------------------------------------

    focusOnFirstError() {
        //let errMsg = "";
        for (const key of Object.keys(this.workRequestForm.controls)) {
            if (this.workRequestForm.controls[key].invalid) {
                const focusables = ["input", "select", "mat-select", "textarea"];
                const input = this.el.nativeElement.querySelector(
                    focusables.map((x) => `${x}.ng-invalid`).join(",")
                );
                if (input) {
                    this.formError = input.dataset.placeholder;
                    input.focus();
                }

                /*
                        //TODO: make this more generic and not specific to this app. need to look for formgroup Array somehow
                      if (key !== "requestMilestones" && key != "requestResources") {
                          //const invalidControl = this.el.nativeElement.querySelector('[formcontrolname="' + key + '"]');
                          ( < any > this.workRequestForm.get(key)).nativeElement.focus();
                          errMsg = "Please correct error with " +  this.globalService.titleCaseString(key);
                          ( < any > this.workRequestForm.get(key)).nativeElement.focus();
                          
                          //var x = invalidControl.closet('mat-tab-label').attr('tab-index');
                          //invalidControl.focus();
                          break;
                      } else if (key == "requestMilestones") {
                          
                          for (var formGroup of this.requestMilestones.controls) {   
                              let fg = formGroup as FormGroup;
                              for (const key of Object.keys(fg.controls)) {
                                  if (fg.controls[key].invalid) {
                                 
                                      const invalidControl = this.el.nativeElement.querySelector('.ng-invalid[formcontrolname="' + key + '"]');
                                      //var x = invalidControl.closet('mat-tab-label').attr('tab-index');
                                      invalidControl.focus();
                                      errMsg = "Please correct error with Milestone " +  this.globalService.titleCaseString(key);
                                      break;
                                  }
                              }
        
                          }
                      } else if (key == "requestResources") {
                          for (var formGroup of this.requestResources.controls) {   
                              let fg = formGroup as FormGroup;
                              for (const key of Object.keys(fg.controls)) {
                                  if (fg.controls[key].invalid) {
                                 
                                      const invalidControl = this.el.nativeElement.querySelector('.ng-invalid[formcontrolname="' + key + '"]');
                                      //var x = invalidControl.closet('mat-tab-label').attr('tab-index');
                                      invalidControl.focus();
                                      errMsg = "Please correct error with Request Resource " +  this.globalService.titleCaseString(key);
                                      break;
                                  }
                              }
        
                          }
                      }
                      */
            }
        }
        //Now check PM Form
        for (const key of Object.keys(this.pmForm.controls)) {
            if (this.pmForm.controls[key].invalid) {
                const focusables = ["input", "select", "mat-select", "textarea"];
                const input = this.el.nativeElement.querySelector(
                    focusables.map((x) => `${x}.ng-invalid`).join(",")
                );
                if (input) {
                    this.formError = input.dataset.placeholder;
                    input.focus();
                }
            }
        }
        //if (errMsg.length > 0) {
        //    this.formError = errMsg;
        // }
    }

    clearControl(ctrl: AbstractControl) {
        ctrl.setValue(null);
    }
    clearADUser(ctrl: AbstractControl) {
        ctrl.setValue(null);
        this.filteredAzureUsers = this.defaultAzureUsers;
        //this.selectedSponsor = null;
    }

    //#region Service Call to update DB
    cleanForm() {
        if (this.workRequest.traSosCompleted === this.QUESTION_NO) {
            this.workRequest.sensitivityLevel = null;
        }
        if (this.workRequest.executiveApproval === this.QUESTION_NO) {
            this.workRequest.businessSponsor = null;
        }
        if (this.workRequest.registrationRequired === this.QUESTION_NO) {
            this.workRequest.registrationReason = null;
        }

        if (this.workRequest.requestType !== GlobalConstants.REQUEST_TYPE_PROJECT) {
            // this.workRequest.applicationOwner = null;
            this.workRequest.partOfSppOpPlan = null;
            this.workRequest.approvedBudget = null;
            this.workRequest.executiveApproval = null;
            this.workRequest.businessSponsor = null;
            this.workRequest.registrationRequired = null;
            this.workRequest.registrationReason = null;
            this.workRequest.traSosCompleted = null;
            this.workRequest.sensitivityLevel = null;
            this.workRequest.piaCompleted = null;
            this.workRequest.applicationType = null;
            this.workRequest.authenticationMethod = null;
            this.workRequest.numberOfUsers = null;
            this.workRequest.apiRequirements = null;
            this.workRequest.publicFacingURLNeeded = null;

            //Project fields entered by Admin
            this.workRequest.phaseInfo = null;
            this.workRequest.projectType = null;
            this.workRequest.projectMethodology = null;
            this.workRequest.sppInfo = null;
            this.workRequest.tShirtSize = null;
            this.workRequest.ippmStatus = null;
            this.workRequest.projectTitle = null;
            this.workRequest.fundingSource = null;
            this.workRequest.projectGovernance = null;
            this.workRequest.portfolio = null;
            this.workRequest.projectCategory = null;

            //PM Fields.
            this.workRequest.projectDescription = null;
            this.workRequest.projectStartDate = null;
            this.workRequest.projectDeliveryDate = null;
            this.workRequest.projectRevisionDate = null;
            this.workRequest.projectRevisionReason = null;

            this.workRequest.projectStatus = null;
            this.workRequest.previousProjectStatus = null;

            this.workRequest.inScope = null;
            this.workRequest.outOfScope = null;
            this.workRequest.risks = null;
            this.workRequest.riskMitigation = null;
            this.workRequest.objectives = null;
            this.workRequest.decisions = null;
            this.workRequest.upcomingActivities = null;
            this.workRequest.keyAccomplishments = null;

            this.workRequest.stakeholderResources = [];
            this.workRequest.pmMilestones = [];
        }
        if (
            this.workRequest.requestType !== GlobalConstants.REQUEST_TYPE_CONSULTATION
        ) {
            this.workRequest.traPiaSasRating = null;
            this.workRequest.consultationType = null;
        }
    }

    deleteWorkRequest(): void {
        if (this.workRequest.workRequestId) {
            this.spinner.show();
            this.workRequestService
                .deleteWorkRequest(Number(this.workRequest.workRequestId))
                .subscribe({
                    next: () => {
                        this.globalService.deleteItemFromCache(
                            GlobalConstants.ADMIN_DATA_STORED_KEY,
                            "workRequestId",
                            this.workRequest.workRequestId
                        );
                        this.alertService.info(this.msg.deleted, this.saveMesageOptions);
                        this.doViewNavigation();
                    },
                    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
                    error: (err: any) => {
                        this.handleError(err.message);
                    },
                });
        }
    }
    deleteWorkRequestAdmin(): void {
        Swal.fire({
            title: "Do you want to continue?",
            html: "Please confirm you want to delete this request?. <br><br>Requests are logically deleted and will no longer be seen in the UI.",
            showCancelButton: true,
            confirmButtonText: "Yes",
            denyButtonText: "No",
            customClass: {
                actions: "my-actions",
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
            },
        }).then((result) => {
            if (result.isConfirmed) {
                this.deleteWorkRequestAdminConfirmed();
            }
        });
    }

    deleteWorkRequestAdminConfirmed(): void {
        if (this.workRequest.workRequestId) {
            this.spinner.show();
            this.workRequestService
                .deleteWorkRequestAdmin(Number(this.workRequest.workRequestId))
                .subscribe({
                    next: () => {
                        this.globalService.deleteItemFromCache(
                            GlobalConstants.ADMIN_DATA_STORED_KEY,
                            "workRequestId",
                            this.workRequest.workRequestId
                        );
                        this.alertService.info(this.msg.deleted, this.saveMesageOptions);
                        this.doViewNavigation();
                    },
                    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
                    error: (err: any) => {
                        this.handleError(err.message);
                    },
                });
        }
    }

    escapeWorkRequestHTML(wr: WorkRequest): void {
        wr.inScope = wr.inScope ? escapeHtml(wr.inScope) : null;
        wr.outOfScope = wr.outOfScope ? escapeHtml(wr.outOfScope) : null;
        wr.risks = wr.risks ? escapeHtml(wr.risks) : null;
        wr.riskMitigation = wr.riskMitigation ? escapeHtml(wr.riskMitigation) : null;
        wr.objectives = wr.objectives ? escapeHtml(wr.objectives) : null;
        wr.decisions = wr.decisions ? escapeHtml(wr.decisions) : null;
        wr.upcomingActivities = wr.upcomingActivities ? escapeHtml(wr.upcomingActivities) : null;
        wr.keyAccomplishments = wr.keyAccomplishments ? escapeHtml(wr.keyAccomplishments) : null;
        
    }
    //We have post and update since they can submit all in one.

    updateDatabase(status: string, message: string) {
        if (this.workRequestForm.valid) {
            this.spinner.show();
            this.disableAllButtons();

            this.getDataFromForm();
            this.cleanForm();
            this.workRequest.status = status;
            this.escapeWorkRequestHTML(this.workRequest);
            if (this.workRequest.workRequestId !== 0) {
                this.workRequestService.updateWorkRequest(this.workRequest).subscribe({
                    next: (wr: WorkRequest) => {
                        this.globalService.updateItemInCache(
                            GlobalConstants.ADMIN_DATA_STORED_KEY,
                            "workRequestId",
                            this.workRequest.workRequestId,
                            this.workRequest
                        );
                        this.doViewNavigation();
                        this.alertService.info(message, this.saveMesageOptions);
                        //this is the only situtation when a user sets status to submitted
                        //Moved to backend API
                        //if (this.workRequest.status === GlobalConstants.STATUS_SUBMITTED) {
                        //    this.emailService.sendNewRequestEmail(this.workRequest);
                        //}
                    },
                    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
                    error: (err: any) => {
                        const msg = err.message;
                        this.handleError(msg);
                    },
                });
            } else {
                this.workRequestService.postWorkRequest(this.workRequest).subscribe({
                    next: (wr: WorkRequest) => {
                        this.workRequest = wr;
                        this.doViewNavigation();
                        this.alertService.info(message, this.saveMesageOptions);
                        //Moved to backend API
                        //if (this.workRequest.status === GlobalConstants.STATUS_SUBMITTED) {
                        //    this.emailService.sendNewRequestEmail(this.workRequest);
                        //}
                    },
                    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
                    error: (err: any) => {
                        const msg = err.message;
                        this.handleError(msg);
                    },
                });
            }
        } else {
            this.focusOnFirstError();
        }
    }

    /*
      checkPMMiletones(): boolean {
          let milestonesOk = false;
          this.milestoneReportingError = "At least one milestone must be selected for reporting.";
          if (this.workRequest.pmMilestones) {
              for (const m of this.workRequest.pmMilestones) {
                  if (m.showInReporting) {
                      milestonesOk = true;
                      this.milestoneReportingError = "";
                  }
              }
              if (this.workRequest.pmMilestones.length == 0) {
                  milestonesOk = true;
                  this.milestoneReportingError = "";
              }
          }
          
          return milestonesOk;
      }
          */

    updateDatabasePM(message: string) {
        if (this.workRequestForm.valid && this.pmForm.valid) {
            //Since Admins can change,
            this.getDataFromForm();

            if (
                this.workRequest.requestType === GlobalConstants.REQUEST_TYPE_PROJECT
            ) {
                this.getPMDataFromForm();
                /*
                        if (!this.checkPMMiletones()) {
                            this.scrollTo("milestone-error");
                            return;
                        }
                        */
            }
            this.spinner.show();
            this.disableAllButtons();
            this.cleanForm();
            this.escapeWorkRequestHTML(this.workRequest);
            if (this.workRequest.workRequestId !== 0) {
                this.workRequestService
                    .updateWorkRequestPM(this.workRequest)
                    .subscribe({
                        next: () => {
                            this.doViewNavigation();
                            this.alertService.info(message, this.saveMesageOptions);
                        },
                        // eslint-disable-next-line  @typescript-eslint/no-explicit-any
                        error: (err: any) => {
                            const msg = err.message;
                            this.handleError(msg);
                        },
                    });
            } else {
                this.alertService.error(
                    "Programming Error: PM should NOT be creating requests"
                );
                this.spinner.hide();
            }
        } else {
            this.focusOnFirstError();
        }
    }

    updateDatabaseAdmin(
        status: string,
        message: string,
        sendStatusEmail: boolean
    ) {
        this.setDynamicValidations(status);
        if (this.workRequestForm.valid && this.pmForm.valid) {
            this.workRequest.status = status;

            this.getDataFromForm();
            this.getPMDataFromForm();

            /*
                  if (!this.checkPMMiletones()) {
                      this.scrollTo("milestone-error");
                      return;
      
                  }
                  */
            this.spinner.show();
            this.disableAllButtons();

            this.cleanForm();
            this.escapeWorkRequestHTML(this.workRequest);
            if (this.workRequest.workRequestId !== 0) {
               
                this.workRequestService
                    .updateWorkRequestAdmin(this.workRequest, sendStatusEmail)
                    .subscribe({
                        next: () => {
                            this.globalService.updateItemInCache(
                                GlobalConstants.ADMIN_DATA_STORED_KEY,
                                "workRequestId",
                                this.workRequest.workRequestId,
                                this.workRequest
                            );
                            this.doViewNavigation();
                            this.alertService.info(message, this.saveMesageOptions);
                            // Moved to backend API 
                            //if (sendStatusEmail) {
                            //    this.emailService.sendStatusEmail(this.workRequest);
                            //}
                        },
                        // eslint-disable-next-line  @typescript-eslint/no-explicit-any
                        error: (err: any) => {
                            const msg = err.message;
                            this.handleError(msg);
                        },
                    });
            } else {
                this.alertService.error(
                    "Programming Error: Admin should NOT be creating requests"
                );
                this.spinner.hide();
            }
        } else {
            this.focusOnFirstError();
        }
    }

    resetRequestStatus() {
        this.spinner.show();
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.workRequestService
            .setWorkRequestStatus(this.workRequest.workRequestId!, this.resetStatus)
            .subscribe({
                next: () => {
                    this.workRequest.status = this.resetStatus;
                    this.globalService.updateItemInCache(
                        GlobalConstants.ADMIN_DATA_STORED_KEY,
                        "workRequestId",
                        this.workRequest.workRequestId,
                        this.workRequest
                    );
                    this.doViewNavigation();
                    this.alertService.info(
                        "The status of work request has been updated.",
                        this.saveMesageOptions
                    );
                    this.spinner.hide();
                    // this has been moved to the backend API
                    //this.emailService.sendStatusEmail(this.workRequest);
                },
                // eslint-disable-next-line  @typescript-eslint/no-explicit-any
                error: (err: any) => {
                    const msg = err.message;
                    this.handleError(msg);
                    this.spinner.hide();
                },
            });
    }

    deleteForm() {
        if (this.screenMode === GlobalConstants.REQUEST_FORM_MODE_USER) {
            this.deleteWorkRequest();
        } else {
            this.deleteWorkRequestAdmin();
        }
    }

    saveForm() {
        if (this.screenMode === GlobalConstants.REQUEST_FORM_MODE_USER) {
            this.updateDatabase(GlobalConstants.STATUS_DRAFT, this.msg.saved);
        } else {
            this.updateDatabaseAdmin(
                GlobalConstants.STATUS_DRAFT,
                this.msg.saved,
                false
            );
        }
    }
    submitForm() {
        if (this.screenMode === GlobalConstants.REQUEST_FORM_MODE_USER) {
            this.updateDatabase(GlobalConstants.STATUS_SUBMITTED, this.msg.submitted);
        } else {
            this.updateDatabaseAdmin(
                GlobalConstants.STATUS_SUBMITTED,
                this.msg.submitted,
                this.determineToSendNotification()
            );
        }
    }
    updateForm() {
        if (this.screenMode === GlobalConstants.REQUEST_FORM_MODE_USER) {
            this.updateDatabase(this.workRequest.status!, this.msg.saved);
        } else {
            this.updateDatabaseAdmin(this.workRequest.status!, this.msg.saved, false);
        }
    }
    inProgressForm() {
        this.updateDatabaseAdmin(
            GlobalConstants.STATUS_IN_PROGRESS,
            this.msg.inProgress,
            this.determineToSendNotification()
        );
    }
    internalReviewForm() {
        this.updateDatabaseAdmin(
            GlobalConstants.STATUS_INTERNAL_REVIEW,
            this.msg.internalReview,
            this.determineToSendNotification()
        );
    }
    closeRequestForm() {
        this.updateDatabaseAdmin(
            GlobalConstants.STATUS_CLOSED,
            this.msg.closed,
            this.determineToSendNotification()
        );
    }
    updatePMForm() {
        if (this.screenMode === GlobalConstants.REQUEST_FORM_MODE_PM) {
            this.updateDatabasePM(this.msg.saved);
        } else {
            this.alertService.error(
                "Programming errors. Non-PMs can't do this update."
            );
        }
    }

    determineToSendNotification() {
        return this.skipEmailNotifications.value === true ? false : true;
    }
    //#endregion

    doViewNavigation() {
        this.spinner.hide();
        if (getPreviousViewFromStorage() !== "") {
            this.router.navigate([getPreviousViewFromStorage()]);
        } else {
            if (this.screenMode === GlobalConstants.REQUEST_FORM_MODE_USER) {
                this.router.navigate(["/my-work-requests"]);
            } else {
                this.router.navigate(["/work-requests"]);
            }
        }
    }

    scrollTo(target: string) {
        //this.scroller.scrollToAnchor("targetGreen");
        document.getElementById(target)?.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
        });
    }

    /**
     *
     * @param msg
     */
    handleError(msg: string) {
        this.spinner.hide();
        this.viewportScroller.scrollToPosition([0, 0]);
        this.enableAllButtons();
        this.alertService.error(msg);
    }

    goBack() {
        this.location.back();
    }

    formatValue(objString?: string) {
        const formattedValues: string[] = [];
        let newValesJSON =JSON.parse(objString ?? "{}");
        
        Object.keys(newValesJSON).forEach((key: string) => {
            const newValue = newValesJSON[key] ?? "<blank>";
            //formattedValues[this.globalService.titleCaseString(key)] = newValesJSON[key];
            formattedValues.push(this.globalService.titleCaseString(key.replace("UTC","")) + " : " + newValue);
        });
        return formattedValues.join("<br>");
    }
    formatValues(e: WorkRequestAuditView): WorkRequestAuditView {
        //const formattedValues: Record<string, any> = {};

       // e.newValues = JSON.stringify(formattedValues, null, 2).replace("{","").replace("}","");
        e.tableName = this.globalService.titleCaseString(e.tableName);
       e.newValues = this.formatValue(e.newValues);
       e.oldValues = this.formatValue(e.oldValues);
        return e;

    }
    getAuditLog() {
        //Get the audit log ONCE
        //this.workRequestAuditView.paginator = null;
        if (
            !this.workRequest.workRequestId ||
            this.workRequest.workRequestId === 0
        ) {
            return;
        }
        if (this.workRequestAuditView.data.length === 0) {
            this.workRequestAuditView.paginator = this.paginator;

            if (
                !isNaN(Number(this.workRequest.workRequestId)) &&
                this.workRequestAuditView.data.length === 0
            ) {
                this.spinner.show();
                this.workRequestService
                    .getWorkRequestAuditLog(
                        parseInt(this.workRequest.workRequestId.toString())
                    )
                    .subscribe({
                        next: (entries: WorkRequestAuditView[]) => {
                            //Skip over any initial entry as the display will be big and confusing
                            const displayedEntries: WorkRequestAuditView[] = [];
                            for (const e of entries) {
                                if (!(e.oldValues === null && e.tableName === "WorkRequest")) {
                                    displayedEntries.push(this.formatValues(e));
                                }
                            }
                            this.workRequestAuditView.data = displayedEntries;
                            this.spinner.hide();
                        },
                        error: () => {
                            this.spinner.hide();
                        },
                    });
            }
        }
    }

    //------------------------------------------
    // Utility Functions
    //------------------------------------------

    decodeEventType(eventType: string): string {
        let ret = "";
        if (eventType === "M") ret = "Modified";
        if (eventType === "D") ret = "Removed";
        if (eventType === "A") ret = "Added";
        return ret;
    }

    setDepartmentDropdown() {
        this.orgDataService.getDepartments().subscribe({
            next: (entries: any) => {
                for (const d of entries) {
                    if (d != null && d.trim().length > 0) {
                        this.departments.push({ key: d, value: d });
                    }
                }
                console.log(this.departments);
                this.changeDetectorRef.detectChanges();
            },
        });
    }

    // don't use ngIf in the tab HTML or the exporter will not be defined.
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    exportData(format: any) {
        if (
            !this.workRequest.workRequestId ||
            this.workRequest.workRequestId === 0
        ) {
            return;
        }
        this.displayedAuditlogColumns = this.exportAuditlogColumns.map((x) => x);
        this.changeDetectorRef.detectChanges();
        setTimeout(() => {
            this.exporter.exportTable(format, {
                fileName: this.workRequest.wrNumber + "_auditlog",
                Props: {
                    Author: GlobalConstants.siteTitle,
                },
            });
        }, 100);
    }

    exportCompleted() {
        this.displayedAuditlogColumns = this.stdAuditlogColumns.map((x: any) => x);
    }
}
